import React, { useEffect, useState } from 'react'

//Components
import MainCard from '../../../components/MainCard/MainCard';
import FichaFormularioPGRSContainer from './components/FichaFormularioPGRSContainer';

//Api
import pgrs_api from '../../../api/pgrs_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Context
import { useAuth } from '../../../context/auth';
import NovoFormularioPGRS from './NovoFormularioPGRS';



export default function FichaFormularioPGRS({ id, btnVoltar }) {
    const { setLoading } = useAuth();

    const [formularioPGRS, setFormularioPGRS] = useState(null);

    const [editar, setEditar] = useState(false);

    function loadFormularioPGRS() {
        setLoading(true);
        pgrs_api.GetItem(id).then(response => {
            if (response.data && response.data.tbFormularioPGRSBlocos.length > 0) {
                response.data.tbFormularioPGRSBlocos = response.data.tbFormularioPGRSBlocos.map(item => {
                    item.tbFormularioPGRSBlocoQuestoes = item.tbFormularioPGRSBlocoQuestoes.map(questao => {
                        questao.sequencia = questao.sequencia.toString();
                        if (questao.tipoValor === "Lista") {
                            questao.tbFormularioPGRSBlocoQuestaoOpcoes = questao.tbFormularioPGRSBlocoQuestaoOpcoes.map(value => {
                                const _option = { label: value.valor, value: value.valor };
                                if (value.id)
                                    _option.id = value.id;
                                return _option;
                            });
                        }
                        return questao;
                    });
                    return item;
                });
            }
            if (response.data && response.data.tbFormularioPGRSDocumentos.length > 0) {
                response.data.tbFormularioPGRSDocumentos = response.data.tbFormularioPGRSDocumentos.map(doc => {
                    doc.obrigatorio = doc.obrigatorio.toString();
                    return doc;
                });
            }
            if (response.data && response.data.tbFormularioPGRSModalidades.length > 0) {
                response.data.tbFormularioPGRSModalidades = response.data.tbFormularioPGRSModalidades.map(modalidade => {
                    modalidade.value = modalidade.tbTipoColeta_Id;
                    modalidade.label = modalidade.descricao;
                    return modalidade
                })
            }
            setFormularioPGRS(response.data);
        })
            .catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }


    useEffect(() => {
        if (id)
            loadFormularioPGRS();
    }, []);

    if (!!formularioPGRS?.id && editar == true)
        return <NovoFormularioPGRS
            btnVoltar={btnVoltar}
            formularioPGRS={formularioPGRS}
        />

    return (
        <MainCard  
            btnVoltarInTop={btnVoltar}
            btnEditarInTop={() => setEditar(true)} 
        >
            <FichaFormularioPGRSContainer 
                formulario={formularioPGRS} 
            />
        </MainCard>
    )
}
